module.exports = __webpack_public_path__ + "static/media/unnamed.48a9a603.jpg";